// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2nE_f","footer":"ReportModalFilter_footer__39hPF"};